var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "生成合同",
            visible: _vm.dialog,
            width: _vm.getIsMobile ? "100%" : "70%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.handleClose,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.data, border: "" } },
            [
              _c("el-table-column", {
                attrs: { label: "序号", prop: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "型号", prop: "xhname" },
              }),
              _c("el-table-column", {
                attrs: { label: "品牌", prop: "source" },
              }),
              _c("el-table-column", {
                attrs: { label: "数量", prop: "num" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入数量" },
                          model: {
                            value: row.num,
                            callback: function ($$v) {
                              _vm.$set(row, "num", _vm._n($$v))
                            },
                            expression: "row.num",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "单价", prop: "price" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入单价" },
                          model: {
                            value: row.price,
                            callback: function ($$v) {
                              _vm.$set(row, "price", $$v)
                            },
                            expression: "row.price",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "总价", prop: "zprice" },
              }),
              _c("el-table-column", {
                attrs: { label: "备注", prop: "bz" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入备注" },
                          model: {
                            value: row.bz,
                            callback: function ($$v) {
                              _vm.$set(row, "bz", $$v)
                            },
                            expression: "row.bz",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "formRef",
              staticStyle: { "margin-top": "20px" },
              attrs: { model: _vm.form },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "是否含税", prop: "shui" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.shui,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "shui", $$v)
                        },
                        expression: "form.shui",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("含税")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("未税")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-top": "8px" },
              attrs: { type: "primary" },
              on: { click: _vm.openCompany },
            },
            [_vm._v("选择联系人")]
          ),
          _vm.showInfo
            ? _c(
                "el-card",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c("Contact", {
                    ref: "contactRef",
                    attrs: { allInfo: _vm.allInfo, editInfo: _vm.editInfo },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("el-divider", [_vm._v("开票资料")]),
          _c("InvoiceInfo", {
            ref: "invoiceInfoRef",
            attrs: { id: _vm.companyId },
            on: { getInfo: _vm.getInfo },
          }),
          _c(
            "el-button",
            {
              staticStyle: { "margin-top": "8px" },
              attrs: { type: "primary" },
              on: { click: _vm.quotationContract },
            },
            [_vm._v("生成合同")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择公司联系人",
            visible: _vm.showCompany,
            width: _vm.getIsMobile ? "100%" : "70%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.handleClose,
            "append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCompany = $event
            },
          },
        },
        [
          _c("CompanyContact", {
            attrs: { contractId: _vm.companyId },
            on: { quotationContact: _vm.getContact },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }